import { useAuthContext } from '@/features/auth/context'
import { EValveType } from '@/features/config/components/sidebar/HydraulicRule/FormValveView/constant'
import useSearchFlowRuleId from '@/features/config/hooks/hydraulic/flowRule/useSearchFlowRuleId'
import useTranslation from '@/hooks/useTranslation'
import { selectTheme } from '@/store/selectors/ThemeSelector'
import { mode_type } from '@/theme/types/constants'
import { Box, Typography } from '@mui/material'
import { useSelector } from 'react-redux'

const CustomOptionFlowValve = (props: any) => {
  const { t } = useTranslation()
  const { data, innerRef, innerProps, isDisabled } = props

  const { interfaceId } = useAuthContext()

  const { data: dataRuleDetail } = useSearchFlowRuleId(
    Number(interfaceId||0),
    Number(data?.flowRuleId),
  )

  const themeMode = useSelector(selectTheme)

  const isDarkMode = themeMode === mode_type.dark

  return (
    <Box
      ref={innerRef}
      {...innerProps}
      sx={{
        padding: '8px',
        background: isDisabled
          ? isDarkMode
            ? '#555'
            : '#dfdfdf'
          : isDarkMode
            ? '#333'
            : '#f5f5f5',
        // marginBottom: "1px",
        borderRadius: isDisabled ? '0' : '5px',
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        opacity: isDisabled ? 0.3 : 1,
        paddingBottom: '15px',
        '&:hover': {
          background: isDisabled
            ? isDarkMode
              ? '#555'
              : '#dfdfdf'
            : isDarkMode
              ? '#444'
              : '#e0e0e0',
        },
      }}
    >
      <Typography variant="body2" sx={{ pb: 1.1 }}>
        <strong>{t('formsLabelsPipe')}:</strong> {dataRuleDetail?.pipeName}
      </Typography>

      <Typography variant="body2" sx={{ pb: 1.1 }}>
        <strong>{t('flowValveType')}:</strong> {EValveType[data.type]}
      </Typography>

      <Typography variant="body2" sx={{ pb: 1.1 }}>
        <strong>{t('ioName')}</strong> {data.io}
      </Typography>

      <Typography variant="body2">
        <strong>{t('ioAddress')}</strong> {data.address}-{data.index}
      </Typography>
    </Box>
  )
}

export default CustomOptionFlowValve
